import { useDevice } from "@utilities/react/get-device/get-device";
import clsx from "clsx";
import { useEffect, useRef, useState } from "react";
import styles from "./C282_Electives.module.scss";
import ElectiveItem, { Course } from "./ElectiveItem";

export interface ElectivesProps {
  courses: Course[];
  singleDisplay?: boolean;
  defaultOpen?: boolean;
  displayFacultyList?: boolean;
  columns?: number;
}

const Electives = (props: ElectivesProps) => {
  const {
    courses,
    singleDisplay = true,
    defaultOpen = false,
    displayFacultyList = true,
    columns = 4,
  } = props;
  const itemRefs = useRef([]);
  const [minHeight, setMinHeight] = useState(0);
  const device = useDevice();
  const isMobile = device === "mobile";

  const getInitialOpenStates = (item) =>
    item.map((_item, index) => (index === 0 ? defaultOpen : false));
  const [openStates, setOpenStates] = useState<boolean[]>([]);

  const handleOpenStateChange = (index, newState) => {
    setOpenStates((previousStates) => {
      const newStates = [...previousStates];
      newStates[index] = newState;
      return newStates;
    });
  };

  const closeAll = () => {
    setOpenStates((previousStates) => previousStates.map(() => false));
  };

  useEffect(() => {
    if (courses && courses.length) setOpenStates(getInitialOpenStates(courses));
  }, [courses]);

  useEffect(() => {
    const computeHeights = () => {
      if (itemRefs.current.length === 0) return;

      let maxHeight = 0;
      itemRefs.current.forEach((ref) => {
        if (ref) {
          const height = ref.getBoundingClientRect().height;
          if (height > maxHeight) {
            maxHeight = height;
          }
        }
      });

      setMinHeight(maxHeight);
    };

    const requestId = requestAnimationFrame(computeHeights);
    window.addEventListener("resize", computeHeights);

    return () => {
      cancelAnimationFrame(requestId);
      window.removeEventListener("resize", computeHeights);
    };
  }, [courses, isMobile]);

  const setItemRef = (index) => (el) => {
    itemRefs.current[index] = el;
  };

  return courses && courses.length ? (
    <div className="outer-wrap white">
      <div
        className={clsx(
          "component",
          styles.electives,
          "electives",
          "single-display",
          "blue"
        )}
        data-row-items={columns}
      >
        <div className="wrapper">
          <ul className={styles["elective-accordion"]}>
            {courses.length > 0 &&
              courses.map((course, index) => (
                <ElectiveItem
                  key={`${course.courseTypeTitle}-${index}`}
                  index={index}
                  ref={setItemRef(index)}
                  minHeight={isMobile ? 0 : minHeight}
                  course={course}
                  openStates={openStates}
                  closeAll={closeAll}
                  handleOpenStateChange={handleOpenStateChange}
                  singleDisplay={singleDisplay}
                  displayFacultyList={displayFacultyList}
                />
              ))}
          </ul>
        </div>
      </div>
    </div>
  ) : null;
};

export default Electives;
